import React from 'react'
import { Props_SnippetHeading } from './Heading.props'

const SnippetHeading = (props: Props_SnippetHeading) => {
    const { snippet } = props
    const classHeadingAlignment = snippet?.alignment?.value ? `snippet-heading--alignment-${snippet.alignment.value}` : ''

    return (
        <section className={`snippet-heading ${classHeadingAlignment}`}>
            { snippet?.level?.value && React.createElement(snippet.level.value, { className: 'snippet-heading__heading' }, snippet?.heading?.value) }
        </section>
    )
}

export default SnippetHeading